import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from 'reactstrap';

const KEY = 'type';
const TOTAL = 'total';
const RANKING = 'ranking';

const ListBy = ({ onDataChange, type }) => {
  const totalSelected = type === TOTAL ? 'selected-option' : '';
  const rankingSelected = type === RANKING ? 'selected-option' : '';

  return (
    <div className="row config-container align-items-center">
      <div className="config-title mr-3">
        List by
      </div>
      <ButtonGroup className="options-list">
        <Button className={`option-title ${totalSelected}`} onClick={() => { onDataChange(KEY, TOTAL); }}>
          Total
        </Button>
        <Button className={`option-title ${rankingSelected}`} onClick={() => { onDataChange(KEY, RANKING); }}>
          Ranking
        </Button>
      </ButtonGroup>
    </div>
  );
};

ListBy.propTypes = {
  onDataChange: PropTypes.func,
  type: PropTypes.string
};

ListBy.defaultProps = {
  onDataChange: () => { },
  type: ''
};

export default ListBy;



// WEBPACK FOOTER //
// ./src/components/dashboard/list/configuration-elements/ListBy.js